function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "#637280",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M5.714.029a2.546 2.546 0 0 0-2.428 1.828h-2.6c-.4 0-.686.314-.686.714 0 .4.314.715.714.715h2.6C3.6 4.343 4.6 5.114 5.743 5.114A2.554 2.554 0 0 0 8.2 3.286h10.543c.4 0 .714-.315.714-.715 0-.4-.314-.714-.714-.714H8.2C7.857.8 6.886.03 5.714.03zm.029 1.428c.6 0 1.114.486 1.114 1.114 0 .629-.514 1.115-1.114 1.115a1.116 1.116 0 0 1 0-2.229zM14.314 5.743a2.546 2.546 0 0 0-2.428 1.828H.714A.69.69 0 0 0 0 8.286c0 .4.314.714.714.714h11.172c.285 1.057 1.285 1.829 2.428 1.829A2.554 2.554 0 0 0 16.771 9h1.972c.4 0 .714-.314.714-.714 0-.4-.314-.715-.714-.715H16.77a2.554 2.554 0 0 0-2.457-1.828zm.029 1.428a1.116 1.116 0 0 1 0 2.229c-.6 0-1.114-.486-1.114-1.114 0-.629.485-1.115 1.114-1.115zM9.143 12.029a2.546 2.546 0 0 0-2.429 1.828h-6a.69.69 0 0 0-.714.714c0 .4.314.715.714.715h6.029c.286 1.057 1.286 1.828 2.428 1.828a2.554 2.554 0 0 0 2.458-1.828h7.114c.4 0 .714-.315.714-.715 0-.4-.314-.714-.714-.714H11.6a2.554 2.554 0 0 0-2.457-1.828zm.028 1.428c.6 0 1.115.486 1.115 1.114a1.116 1.116 0 0 1-2.229 0c.029-.628.514-1.114 1.114-1.114z"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 20,
    height: 18
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/filters.512350a0.svg";
export { SvgComponent as ReactComponent };